<script lang="ts">
    import { _ } from "svelte-i18n";
    import Score from "../../../Score.svelte";
    import type { ModelLocationInfoManager } from "../ModelLocationInfoManager";

    export let manager: ModelLocationInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    let selectedLocationStore = manager.getSelectedLocationStore();

    $: if (typeof $selectedLocationStore !== "undefined") {
        schoolName =
            $selectedLocationStore.tags.get("name") ??
            $_(`${$modelTranslationKeyStore}.info.location.noname`);
        studentCount = Number(
            $selectedLocationStore.tags.get("capacity") ?? "100",
        );
        safetyScore = Math.round(Number(
            $selectedLocationStore.tags.get("_score:bicycle.commute:safety") ??
                "0",
        ) * 10) / 10;
        totalDistance = Number(
            $selectedLocationStore.tags
                .get("_score:bicycle.commute:distance")
                .replace(/,/g, "") ?? "0",
        );
    }

    let schoolName: string = "Klavernest Basisschool";
    let studentCount: number = 360;
    let totalDistance: number = 715;
    let safetyScore: number = 1.5;
</script>

<div class="card-body p-4">
    <p class="mb-2 small">
        {$_("location.p1.part1")} <strong>{studentCount}</strong>
        {$_("location.p1.part2")}
        <strong>{totalDistance}km</strong>
        {$_("location.p1.part3")}
    </p>
    <Score score={safetyScore} class="score-main">
        {safetyScore}
    </Score>
    <p class="mb-2 small">
        {$_("location.p2.part1")}
        <a
            href="https://docs.anyways.eu/vehicle-profiles/bicycle.commute"
            target="_blank">{$_("location.p2.part2")}</a>
        {$_("location.p2.part3")}
    </p>
    <p class="mb-2 text-muted small">
        {$_("location.subtitle")}
    </p>
</div>

<style>
    .scores {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: 100px 120px;
        grid-template-columns: 50% 50%;
        padding: 10px;
        text-align: center;
    }
</style>
